module.exports = __webpack_public_path__ + "assets/img/dc76bdb4793ae9886028988cf59ced99.png";